import { TooltipProvider } from '@/components/ui/tooltip'

import TrafficMetricsCard from './charts/TrafficMetricsCard'
import { TrafficChartsLoading } from './overview/OverviewStates'
import type { PeriodTotals } from '@/lib/utils/previousPeriod'
import type { PeriodSeries, PeriodWindow } from '@/hooks/usePreviousPeriodMetrics'

interface SiteTrafficMetricsProps {
  dashBoardData: any
  period: string
  className?: string
  showRevenue?: boolean
  revenueLoading?: boolean
  /** When set and revenue exists, show Attribution deep-link in card header controls */
  basePath?: string
  /** Previous equal-length period totals (`usePreviousPeriodMetrics`); omit to hide deltas */
  previousTotals?: PeriodTotals | null
  /** Previous window's buckets: the dashed comparison line */
  previousSeries?: PeriodSeries | null
  /** "the previous 7 days": shown as the delta tooltip */
  comparisonPhrase?: string
  /** The previous window, for "vs Sep 12 to Sep 18" on the chart cards */
  previousWindow?: PeriodWindow | null
  /** Stripe or Foxy is set up; false shows "Connect Stripe" under the traffic card */
  revenueConfigured?: boolean
}

export default function SiteTrafficMetrics({
  dashBoardData,
  period,
  className,
  showRevenue,
  revenueLoading,
  basePath,
  previousTotals,
  previousSeries,
  comparisonPhrase,
  previousWindow,
  revenueConfigured,
}: SiteTrafficMetricsProps) {
  if (!dashBoardData?.metrics) {
    return <TrafficChartsLoading showRevenue={showRevenue} />
  }

  return (
    <TooltipProvider>
      <TrafficMetricsCard
        dashBoardData={dashBoardData}
        period={period}
        className={className}
        showRevenue={showRevenue}
        revenueLoading={revenueLoading}
        basePath={basePath}
        previousTotals={previousTotals}
        previousSeries={previousSeries}
        comparisonPhrase={comparisonPhrase}
        previousWindow={previousWindow}
        revenueConfigured={revenueConfigured}
      />
    </TooltipProvider>
  )
}
